function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.5,
    viewBox: "0 0 16 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6479"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "file (6)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41434",
    d: "M11.2 2H5.6A1.6 1.6 0 0 0 4 3.6v12.8A1.6 1.6 0 0 0 5.6 18h9.6a1.6 1.6 0 0 0 1.6-1.6V7.6z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    transform: "translate(-3 -1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41435",
    d: "M13 2v5.6h5.6",
    transform: "translate(-4.8 -1.25)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileI);
export default __webpack_public_path__ + "static/media/fileI.c0985719433226e1fc37cea40f8da737.svg";
export { ForwardRef as ReactComponent };